import React from 'react';

import { Paper, UnstyledButton, UnstyledButtonProps, useMantineTheme } from '@mantine/core';

interface ChatActionButtonProps extends UnstyledButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}

export function ChatActionButton({ children, onClick, disabled = false, ...buttonProps }: ChatActionButtonProps) {
  const theme = useMantineTheme();

  return (
    <UnstyledButton {...buttonProps} onClick={onClick}>
      <Paper
        p={3}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: theme.other.getDimmedColor(buttonProps.bg),
            cursor: disabled ? 'not-allowed' : 'pointer'
          }
        }}>
        {children}
      </Paper>
    </UnstyledButton>
  );
}
